import { Injectable, inject } from '@angular/core';
import {
  CanMatch,
  CanMatchFn,
  Route,
  Router,
  UrlSegment,
} from '@angular/router';
import { map, take } from 'rxjs';
import { CustomActivatedRoute } from '../custom-activated-route';
import { AuthService } from '../services/auth.service';
import { AcessoService } from '../services/acesso.service';
import { PerfilUsuarioService } from '../services/perfil-usuario.service';
import { Store } from '@ngrx/store';
import * as AuthActions from '../store/auth/auth.actions';

export const authGuard = (customRoute: CustomActivatedRoute) => {
  const authService = inject(AuthService);
  const acessoService = inject(AcessoService);
  const store = inject(Store);
  const router = inject(Router);

  function getPreviousUrl(): string {
    const history = router.config;
    const currentUrl = router.url;

    for (let i = history.length - 1; i > 0; i--) {
      if (currentUrl.includes(history[i].path!)) {
        return history[i - 1].path!;
      }
    }

    return '/';
  }

  return authService.getAccessToken().pipe(
    take(1),
    map((accessToken: string) => {
      if (accessToken) {
        const dadosAcesso = acessoService.getAcessos();

        if (dadosAcesso && dadosAcesso.modulos && dadosAcesso.modulos.length > 0) {
          return true;
        }

        const storedAcessos = localStorage.getItem('acessos');
        if (storedAcessos) {
          try {
            const parsed = JSON.parse(storedAcessos);
            acessoService.setAcessos(parsed);
            return true;
          } catch (error) {
            console.error('Erro ao parsear acessos do localStorage:', error);
          }
        }

        console.error('Erro: Sem dados de acesso disponíveis. Redirecionando para login...');
        router.navigate(['/authentication/login']);
        return false;
      } else {
        router.navigate(['/authentication/login']);
        return false;
      }
    })
  );
};
